import { http } from '@/lib/ats-https';
import { FraudDetectorSettingsResponse } from './types';

export const FRAUD_DETECTOR_API = {
  getSettings: async () => {
    try {
      const res = (await http.get(
        '/contact_background_verification/account_settings'
      )) as FraudDetectorSettingsResponse;
      return res?.data ?? { cbv_integration_enabled: false };
    } catch {
      return { cbv_integration_enabled: false };
    }
  },

  updateSettings: async (payload: { cbv_integration_enabled: boolean }) => {
    const res = (await http.put(
      '/contact_background_verification/account_settings',
      payload
    )) as FraudDetectorSettingsResponse;
    return res?.data ?? { cbv_integration_enabled: false };
  },
};
